import { getLabelFromStorage } from '@pb/utils'

import {
  CHECKOUT_ERROR_CODES,
  CHECKOUT_TRACKING_ERROR_TYPES,
  CHECKOUT_TRACKING_SECTIONS,
  OBSERVED_ADDRESS_FORM_ERRORS,
  SHOW_NOTIFICATION_TIME,
  TECHNICAL_ERROR_LABELS,
} from 'features/checkout/constants'
import { showNotification } from 'features/notifications/duck/actions'
import getErrorData from 'helpers/getErrorData'
import { ThunkResult } from 'redux/types'

import { trackError } from '../track'

export const addressError =
  (error: Error, addressId: string): ThunkResult<void> =>
  (dispatch) => {
    const { code } = getErrorData(error)
    const isInvalidDeliveryAddress = code === CHECKOUT_ERROR_CODES.invalidDeliveryAddress
    const notificationMessage = isInvalidDeliveryAddress
      ? getLabelFromStorage(TECHNICAL_ERROR_LABELS.invalidAddress)
      : getLabelFromStorage(TECHNICAL_ERROR_LABELS.selectAddress)

    dispatch(
      showNotification({
        content: notificationMessage,
        type: 'error',
        timespan: SHOW_NOTIFICATION_TIME,
      }),
    )

    dispatch(
      trackError({
        section: CHECKOUT_TRACKING_SECTIONS.deliveryLocation,
        message: notificationMessage,
        id: code,
        errorType: CHECKOUT_TRACKING_ERROR_TYPES.system,
      }),
    )

    if (isInvalidDeliveryAddress) {
      return [{ code: OBSERVED_ADDRESS_FORM_ERRORS.invalidDeliveryAddress, addressId }]
    }

    return [{ code }]
  }
